/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import {Filter} from '../../../model/Filter';

class CounterService {
    /** @ngInject */
    constructor($q, $log, configuration, alarmService, filterService, $rootScope, notificationService,
                actionRequestService, actionRequestProgMesService, preventiveSheetService, dateTimeService) {
        this.$q = $q;
        this.$log = $log;
        this.configuration = configuration;
        this.alarmService = alarmService;
        this.filterService = filterService;
        this.notificationService = notificationService;
        this.actionRequestService = actionRequestService;
        this.actionRequestProgMesService = actionRequestProgMesService;
        this.preventiveSheetService = preventiveSheetService;
        this.dateTimeService = dateTimeService;
        this.$rootScope = $rootScope;
        this.$log.debug('Service \'Counter\' loaded');
    }

    /**
     * Initialise the filters and the counters
     */
    loadCount() {
        this.$rootScope.count = {
            alarm: 0,
            actionRequest: 0,
            preventiveSheet: 0,
            actionRequestProgMes: 0
        };
        this.initAlarmFilters();
        this.initActionRequestFilters();
        this.initActionRequestProgMesFilters();
        this.initPreventiveSheetFilters();
        this.reloadCount();
    }

    /**
     * Reload the counters
     */
    reloadCount() {
        this.alarmCount();
        this.actionRequestCount();
        this.actionRequestProgMesCount();
        this.preventiveSheetCount();
    }

    /**
     * Initialise the alarm filters (pending alarm without action request)
     */
    initAlarmFilters() {
        let alarmStatuses;
        this.alarmFilters = [];
        alarmStatuses=['PENDING'];
        this.alarmFilters.push(
            Filter.alarmStatusFilter(alarmStatuses),
            Filter.nullFilter('actionRequest')
        );
    }

    /**
     * Initialise the action request filters (opened or completed action request)
     */
    initActionRequestFilters() {
        let actionRequestStatuses;
        actionRequestStatuses = ['OPENED', 'COMPLETED'];

        this.actionRequestFilters = [];
        this.actionRequestFilters.push(
            Filter.actionRequestStatusFilter(actionRequestStatuses)
        );
    }

    /**
     * Initialise the action request prog mes filters (opened or completed action request prog mes)
     */
    initActionRequestProgMesFilters() {
        let actionRequestProgMesStatuses;
        actionRequestProgMesStatuses = ['OPENED', 'COMPLETED'];

        this.actionRequestProgMesFilters = [];
        this.actionRequestProgMesFilters.push(
            Filter.actionRequestProgMesStatusFilter(actionRequestProgMesStatuses)
        );
    }

    /**
     * Initialise the preventive sheet filters (late and current week preventive sheet)
     */
    initPreventiveSheetFilters() {
        let preventiveSheetStatuses;
        preventiveSheetStatuses = ['OPENED'];

        this.currentDay = new Date();
        let nextWeek = this.dateTimeService.getFirstDayOfNextWeek(this.currentDay);
        nextWeek = this.dateTimeService.formatLocalDate(nextWeek);
        this.preventiveSheetFilters = [];
        this.preventiveSheetFilters.push(
            Filter.preventiveSheetStatusFilter(preventiveSheetStatuses),
            Filter.lowerOrEqualDateFilter('maxActionDate', nextWeek)
        );
    }

    /**
     * Count the number of pending alarm matching the filters
     */
    alarmCount() {
        return this.handleRestServiceCall(
            this.alarmService.countEntities({
                data: this.filterService.buildFilters(this.alarmFilters)
            }),
            data => {
                this.$rootScope.count.alarm = data.value;
            }
        );
    }

    /**
     * Count the number of action request matching the filters
     */
    actionRequestCount() {
        return this.handleRestServiceCall(
            this.actionRequestService.countEntities({
                data: this.filterService.buildFilters(this.actionRequestFilters)
            }),
            data => {
                this.$rootScope.count.actionRequest = data.value;
            }
        );
    }

    /**
     * Count the number of action request prog mes matching the filters
     */
    actionRequestProgMesCount() {
        return this.handleRestServiceCall(
            this.actionRequestProgMesService.countEntities({
                data: this.filterService.buildFilters(this.actionRequestProgMesFilters)
            }),
            data => {
                this.$rootScope.count.actionRequestProgMes = data.value;
            }
        );
    }

    /**
     * Count the number of preventive sheet matching the filters
     */
    preventiveSheetCount() {
        return this.handleRestServiceCall(
            this.preventiveSheetService.countEntities({
                data: this.filterService.buildFilters(this.preventiveSheetFilters)
            }),
            data => {
                this.$rootScope.count.preventiveSheet = data.value;
            }
        );
    }

    /**
     * Handles a call to a REST service and the potential errors received, by registering an error callback to a submit
     * promise. Errors are handled unless there is a 401 or 403 HTTP status. In this later case, nothing is done as such
     * statuses are handled globally by another component.
     *
     * @param {Promise} submitPromise A promise of the form submission (i.e. a service call).
     * @param {Function} successCallback A callback that will be called if the REST service call succeeds.
     */
    handleRestServiceCall(submitPromise, successCallback) {
        let promise = submitPromise;
        if (successCallback) {
            promise = promise.then(successCallback);
        }
        return promise.then(response => {
            this.validationErrors = null;
            return response;
        }).catch(response => {
            if ((response.status !== 401) && (response.status !== 403)) {
                this.handleResponseError(response);
            }
            return response.data;
        });
    }

    /**
     * Handles client errors received after a failed form submission (HTTP statuses 4xx), and pushes notifications in
     * the UI.
     *
     * @param {Object} response The response data.
     */
    handleResponseError(response) {
        if ((response.status >= 400) && (response.status < 500)) {
            this.validationErrors = response.data.validationErrors;
            if (response.data.errors) {
                for (const errorCode in response.data.errors) {
                    if (response.data.errors.hasOwnProperty(errorCode)) {
                        this.notificationService.pushMessageWithParameters(`api.error.${errorCode}`,
                            response.data.errors[errorCode], this.configuration.NOTIFIER_LEVEL_ERROR);
                    }
                }
            } else {
                this.notificationService.pushMessage(`server.error.${response.status}`,
                    this.configuration.NOTIFIER_LEVEL_ERROR);
            }
        }
    }

}

export { CounterService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/service/CounterService.js